import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import Loading from '../../components/Loading';

const DaswatchDashboardPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasloop-dashboard-page" */ '../../pages/daswatch-dashboard'
    ),
);

const daswatchDashboardRouter = (
  <Route path="daswatch-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <DaswatchDashboardPageComponent />
        </Suspense>
      }
    />
  </Route>
);

export default daswatchDashboardRouter;
